<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="add">手动添加备份</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="备份时间" prop="created_at"></el-table-column>
        <el-table-column label="备份状态" prop="status"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'Dashboard',
  data () {
    return {
      records: []
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    getList() {
      request.get('backups').then(res=>{
        this.records = res.data
      })
    },
    add () {
      this.$message({
        type: 'success',
        message: '已提交备份请求，请稍后查看!'
      })
      request.post('backups').then(() => {
        this.getList()
      })
    },
    del (id) {
      this.$confirm(`确定删除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete('backups/'+id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
